import { Pressable, VStack, Text } from "@gluestack-ui/themed";
import { Icon } from "@repo/core/components/core/Icon";
import { SalesOptionCardProps } from "./types";

export const SalesOptionCard = ({
  name,
  description,
  onPress
}: SalesOptionCardProps) => {
  return (
    <Pressable
      flexDirection="row"
      px="$4"
      py="$3"
      borderRadius="$lg"
      bg="$white"
      alignItems="center"
      onPress={onPress}
    >
      <VStack flex={1} gap="$2">
        <Text
          fontWeight="500"
          $web-fontFamily="Inter"
          fontFamily="Inter_500Medium"
          fontSize="$md"
          color="$secondary700"
        >
          {name}
        </Text>
        <Text
          fontWeight="400"
          $web-fontFamily="Inter"
          fontFamily="Inter_400Medium"
          fontSize="$xs"
          color="$secondary400"
        >
          {description}
        </Text>
      </VStack>
      <VStack pl="$2">
        <Icon name="chevron-right" size={24} />
      </VStack>
    </Pressable>
  );
};
